export function formatCard(value: number | null) {
  return value ? `************${value}` : '-';
}
